import { Segment } from '@mairistem/composants';
import type { Exercice } from '@mairistem/comptabilite';
import { useCreateFiche } from '@mairistem/fiche';
import { getSymbol, Icon, TreeSymbol } from '@mairistem/finances-utils';
import { isNewIdentifiant } from '@mairistem/tools';
import React from 'react';
import CODE_BHM from '../../../../constants/mouvements/codeBHM';
import type { TreeRow } from '../../../../interfaces/pieces/TreeRow';
import './Mouvement.css';

interface CreateMouvementRowProps {
	rowData: TreeRow;
	exercice: Exercice;
}

const CreateMouvementRow = ({ rowData, exercice }: CreateMouvementRowProps) => {
	const createFiche = useCreateFiche({ path: '/liquidations' });

	const parent: TreeRow = getSymbol(rowData, TreeSymbol.PARENT);

	const handleCreateNewMouvement = React.useCallback((): void => {
		createFiche({
			identifiantExercice: exercice?.identifiant,
			identifiantEntite: exercice?.identifiantEntite,
			...(isNewIdentifiant(parent.bordereau?.identifiant)
				? {}
				: {
						identifiantBordereau: parent.bordereau?.identifiant,
						bordereau: parent.bordereau,
					}),
			sens: parent?.bordereau?.sens,
			codeBHM: CODE_BHM.VALUE.BROUILLARD,
			exercice,
		});
	}, [createFiche, exercice, parent.bordereau]);

	return (
		<Segment
			className="create-row mouvement-container"
			onClick={handleCreateNewMouvement}
			data-testid="mouvementRowCreate"
		>
			<Icon name="FilePlus2" iconSet="Lucide" />
			{rowData.libelle}
		</Segment>
	);
};
export default CreateMouvementRow;
